import { 
  ADD_FAVORITE_TEAM, 
  REMOVE_FAVORITE_TEAM, 
  ADD_FAVORITE_COUNTRY, 
  REMOVE_FAVORITE_COUNTRY, 
  ADD_FAVORITE_LEAGUE, 
  ADD_FAVORITE_MATCH, 
  REMOVE_FAVORITE_LEAGUE, 
  REMOVE_FAVORITE_MATCH,
  SET_FAVORITE_STATUS_MATCHES,
  SET_FAVORITE_STATUS_TEAMS,
  SET_FAVORITE_STATUS_LEAGUES, 
} from "./actionTypes";

const initialState = {
  favoriteLeagues: [],
  favoriteMatches: [],
  favoriteCountries: [],
  favoriteTeams: [],
  statusMatches: {
    live: 0,
    nostarted: 0,
    finished: 0,
  },
  statusTeams: {
    live: 0,
    nostarted: 0,
    finished: 0,
  },
  statusLeagues: {
    live: 0,
    nostarted: 0,
    finished: 0,
  },
};

export const FavoriteReducer = (
  state: any = initialState,
  action: any
) => {
  switch (action.type) {
    case ADD_FAVORITE_COUNTRY:

      if (!state.favoriteCountries?.map((league: any) => league.countryId).includes(action.payload.countryId)) {
        return {
          ...state,
          favoriteCountries: [...state.favoriteCountries, action.payload],
        };
      }
      case REMOVE_FAVORITE_COUNTRY:
        return {
          ...state,
          favoriteCountries: state.favoriteCountries?.filter((league: any) => league.countryId !== action.payload.countryId),
        };
    case ADD_FAVORITE_LEAGUE:
      if (!state.favoriteLeagues?.map((league: any) => league.id).includes(action.payload.id)) {
        return {
          ...state,
          favoriteLeagues: [...(state.favoriteLeagues || []), 
            JSON.parse(JSON.stringify(action.payload))
          ],
        };
      } else {
        const updatedLeagues = state.favoriteLeagues?.map((league: any) =>
          league.id === action.payload.id
            ? { ...league, ...JSON.parse(JSON.stringify(action.payload)) }
            : league
        );
        return {
          ...state,
          favoriteLeagues: updatedLeagues,
        };
      }
    case REMOVE_FAVORITE_LEAGUE:
      return {
        ...state,
        favoriteLeagues: state.favoriteLeagues?.filter((league: any) => league.id !== action.payload.id),
      };
    case ADD_FAVORITE_MATCH:
      if (!state.favoriteMatches?.map((match: any) => match.id).includes(action.payload.id)) {
        return {
          ...state,
          favoriteMatches: [...(state.favoriteMatches || []), 
            JSON.parse(JSON.stringify(action.payload))
          ],
        };
      } else {
        const updatedMatches = state.favoriteMatches?.map((match: any) =>
          match.id === action.payload.id
            ? { ...match, ...JSON.parse(JSON.stringify(action.payload)) }
            : match
        );
        return {
          ...state,
          favoriteMatches: updatedMatches,
        };
      }
    case REMOVE_FAVORITE_MATCH:
      return {
        ...state,
        favoriteMatches: state.favoriteMatches?.filter((match: any) => match.id !== action.payload.id),
      };
    case ADD_FAVORITE_TEAM:
      if (!state.favoriteTeams?.map((team: any) => team.id).includes(action.payload.id)) {
        return {
          ...state,
          favoriteTeams: [...(state.favoriteTeams || []), 
            JSON.parse(JSON.stringify(action.payload))
          ],
        };
      } else {
        const updatedTeams = state.favoriteTeams?.map((team: any) =>
          team.id === action.payload.id
            ? { ...team, ...JSON.parse(JSON.stringify(action.payload)) }
            : team
        );
        return {
          ...state,
          favoriteTeams: updatedTeams,
        };
      }
    case REMOVE_FAVORITE_TEAM:
      return {
        ...state,
        favoriteTeams: state.favoriteTeams?.filter((team: any) => team.id !== action.payload.id),
      };
    case SET_FAVORITE_STATUS_MATCHES:
      return {
        ...state,
        statusMatches: action.payload,
      };
    case SET_FAVORITE_STATUS_TEAMS:
      return {
        ...state,
        statusTeams: action.payload,
      };
    case SET_FAVORITE_STATUS_LEAGUES:
      return {
        ...state,
        statusLeagues: action.payload,
      };
    default:
      return state;
  }
};

export default FavoriteReducer;
